export const customStyles = {
    filter: {
        container: (provided) => ({
            display: "inline-block",
            position: "relative",

            width: "100%",
            minHeight: "40px",
            ...provided
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: "40px",
            borderColor: "#DBDBDB",
            boxShadow: state.isFocused ? 0 : 0,
            borderRadius: "4px",
            "&:hover": {
                borderWidth: "2px",
                borderColor: "#DBDBDB"
            },
            ...(state.isDisabled && {
                backgroundColor: "#eff2f7"
            })
        }),
        option: (provided, state) => ({
            ...provided,
            fontWeight: 500,
            color: state.isSelected ? "#fff" : "#EA8D83 ",
            background: state.isSelected ? "#EA8D83 " : "#fff",
            fontSize: "1rem",
            fontFamily: "Nunito Sans",
            textAlign: "center",
            "&:hover": {
                color: "#fff",
                background: "linear-gradient(185.12deg, #EA8D83 -74.08%, #f1b5af 73.64%)"
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            textAlign: "start",
            fontFamily: "Nunito Sans",
            color: "#9a9a9b !important",
            fontSize: "0.875rem",
            width: "100%"
        }),
        singleValue: (provided) => ({
            ...provided,
            textAlign: "start",
            fontFamily: "Nunito Sans",

            width: "100%" // Ensures single selected value remains centered
        }),
        input: (provided) => ({
            ...provided,
            textAlign: "start", // Centers the typing text and placeholder
            fontFamily: "Nunito Sans"
        })
    }
};
